import { memo, useMemo } from 'react';

import { useCarouselItem } from '../../hooks/useCarouselItem';
import type { CardLayout, CarouselLayout } from '../../types';
import Carousel from '../Carousel';

import type { Bucket } from '@shared-types/uefatv.types';

const VodVideo = ({ bucket }: { bucket: Bucket }) => {
  const { carouselData } = useCarouselItem(bucket);
  const cardLayout: CardLayout = useMemo(() => {
    return {
      cardFormat: bucket?.rowTypeData?.displayPosters ? 'portrait' : 'wide',
      hideDescription: bucket?.rowTypeData?.hideMetadata || bucket?.rowTypeData?.displayPosters,
      orientation: bucket?.rowTypeData?.rowCount > 1 ? 'horizontal' : 'portrait',
      transparency: bucket?.rowTypeData?.rowCount === 1,
      content: bucket?.rowTypeData?.displayPosters ? 'over' : 'default',
    };
  }, [bucket?.rowTypeData]);
  const layout: CarouselLayout = useMemo(() => {
    return {
      cardLayout,
      staticFirstSlide: false,
      cardsForColumn: bucket?.rowTypeData?.rowCount,
    };
  }, [bucket?.rowTypeData?.rowCount, cardLayout]);

  return <Carousel data={carouselData} layout={layout} />;
};

export default memo(VodVideo);
